import { z } from 'zod';
/**
 * Cadência semanal — dashboard pessoal de uso da app.
 *
 * Fonte de verdade:
 *   - Análises persistidas (tabela `analyses`)
 *   - Post drafts gerados (tabela `post_drafts`)
 *   - Publicações autodeclaradas (`post_drafts.published_at`)
 *   - Meta semanal (tabela `user_settings`)
 *
 * Sem scrape do LinkedIn — só dados que o user mesmo gerou na app.
 */
export const AnalysisTimelinePointSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string(),
    findingsCount: z.number().int(),
    criticalCount: z.number().int(),
    label: z.string().nullable(),
});
export const RecentDraftSummarySchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string(),
    sourceType: z.enum(['link', 'topic', 'text']),
    sourceInput: z.string(),
    label: z.string().nullable(),
    draftsCount: z.number().int(),
    publishedAt: z.string().nullable(),
});
export const CadenceResponseSchema = z.object({
    // Marcos de uso
    lastAnalysisAt: z.string().nullable(),
    lastPostGeneratedAt: z.string().nullable(),
    lastPostPublishedAt: z.string().nullable(),
    // Janelas
    postsGeneratedLast7Days: z.number().int(),
    postsGeneratedLast30Days: z.number().int(),
    analysesLast30Days: z.number().int(),
    // Meta semanal
    weeklyGoal: z.number().int().nullable(),
    postsPublishedThisWeek: z.number().int(),
    postsPublishedThisMonth: z.number().int(),
    // Timeline
    analysisTimeline: z.array(AnalysisTimelinePointSchema),
    recentDrafts: z.array(RecentDraftSummarySchema),
});
export const SetWeeklyGoalRequestSchema = z.object({
    weeklyGoal: z.number().int().min(0).max(20).nullable(),
});
export const MarkPublishedRequestSchema = z.object({
    draftSetId: z.string().uuid(),
    // ID do draft específico dentro do set (ex: "D01"). Null se o user só
    // marcou o set genérico.
    draftId: z.string().nullable().optional(),
});
//# sourceMappingURL=cadence.js.map